'use strict';

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _toConsumableArray = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var isPlainObject = require('is-plain-obj');

module.exports = function (object) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!isPlainObject(object)) {
    throw new TypeError('Expected a plain object');
  }

  var deep = options.deep;
  var seenInput = [];
  var seenOutput = [];

  var deepSortArray = function deepSortArray(array) {
    var seenIndex = seenInput.indexOf(array);

    if (seenIndex !== -1) {
      return seenOutput[seenIndex];
    }

    var result = [];
    seenInput.push(array);
    seenOutput.push(result);
    result.push.apply(result, _toConsumableArray(array.map(function (item) {
      if (Array.isArray(item)) {
        return deepSortArray(item);
      }

      if (isPlainObject(item)) {
        return sortKeys(item);
      }

      return item;
    })));
    return result;
  };

  var sortKeys = function sortKeys(object) {
    var seenIndex = seenInput.indexOf(object);

    if (seenIndex !== -1) {
      return seenOutput[seenIndex];
    }

    var result = {};
    var keys = Object.keys(object).sort(options.compare);
    seenInput.push(object);
    seenOutput.push(result);

    var _iterator = _createForOfIteratorHelper(keys),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        var value = object[key];

        if (deep && Array.isArray(value)) {
          result[key] = deepSortArray(value);
          continue;
        }

        result[key] = deep && isPlainObject(value) ? sortKeys(value) : value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return result;
  };

  return sortKeys(object);
};